Object.defineProperty(exports,"__esModule",{value:true});var _isEqual2=require("lodash/isEqual");var _isEqual3=_interopRequireDefault(_isEqual2);var _assign2=require("lodash/assign");var _assign3=_interopRequireDefault(_assign2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=require("react");var _react2=_interopRequireDefault(_react);
var _helpers=require("../victory-util/helpers");var _helpers2=_interopRequireDefault(_helpers);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var


Line=function(_React$Component){_inherits(Line,_React$Component);function Line(){_classCallCheck(this,Line);return _possibleConstructorReturn(this,(Line.__proto__||Object.getPrototypeOf(Line)).apply(this,arguments));}_createClass(Line,[{key:"componentWillMount",value:function componentWillMount()
















{
this.style=this.getStyle(this.props);
}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(

nextProps){var _props=
this.props,x1=_props.x1,x2=_props.x2,y1=_props.y1,y2=_props.y2;
var style=this.getStyle(nextProps);
if(x1!==nextProps.x1||x2!==nextProps.x2||y1!==nextProps.y1||y2!==nextProps.y2){
this.style=style;
return true;
}

if(!(0,_isEqual3.default)(style,this.style)){
this.style=style;
return true;
}

return false;
}},{key:"getStyle",value:function getStyle(

props){var
style=props.style,datum=props.datum,active=props.active;
return _helpers2.default.evaluateStyle((0,_assign3.default)({stroke:"black"},style),datum,active);
}},{key:"renderAxisLine",value:function renderAxisLine(


props,style,events){var _props2=
this.props,role=_props2.role,shapeRendering=_props2.shapeRendering,className=_props2.className;
return(
_react2.default.createElement("line",_extends({},
props,{
className:className,
style:style,
role:role||"presentation",
shapeRendering:shapeRendering||"auto",
vectorEffect:"non-scaling-stroke"},
events)));


}},{key:"render",value:function render()

{var _props3=
this.props,x1=_props3.x1,x2=_props3.x2,y1=_props3.y1,y2=_props3.y2,events=_props3.events;
return this.renderAxisLine({x1:x1,x2:x2,y1:y1,y2:y2},this.style,events);
}}]);return Line;}(_react2.default.Component);Line.propTypes={active:_react.PropTypes.bool,className:_react.PropTypes.string,index:_react.PropTypes.number,datum:_react.PropTypes.any,data:_react.PropTypes.array,x1:_react.PropTypes.number,x2:_react.PropTypes.number,y1:_react.PropTypes.number,y2:_react.PropTypes.number,style:_react.PropTypes.object,events:_react.PropTypes.object,role:_react.PropTypes.string,shapeRendering:_react.PropTypes.string};exports.default=Line;


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/lib/victory-primitives/line.js
// module id = 1380
// module chunks = 0